import { QueryClient } from "@tanstack/react-query";

// The deleted entity's own query is marked stale but not refetched: a refetch now 404s while the
// page is still mounted, removeQueries makes SiteEdit's observer refetch anyway (and its loading
// guard then pre-empts the redirect), and leaving it fresh would let Back show the deleted entity.
const markDeletedWithoutRefetch = (
  queryClient: QueryClient,
  queryKey: unknown[]
) => queryClient.invalidateQueries(queryKey, { refetchType: "none" });

export const applySiteDeletedCacheUpdates = (
  queryClient: QueryClient,
  siteId: string
): void => {
  markDeletedWithoutRefetch(queryClient, ["site", siteId]);
  // Customers can't delete sites, so the customer-app's org-with-sites query is left alone.
  queryClient.invalidateQueries(["sites"]);
  queryClient.invalidateQueries(["org"]);
  queryClient.invalidateQueries(["orgs"]);
};

export const applyOrgDeletedCacheUpdates = (
  queryClient: QueryClient,
  orgId: string
): void => {
  markDeletedWithoutRefetch(queryClient, ["org", orgId]);
  queryClient.invalidateQueries(["orgs"]);
};
